import { render, staticRenderFns } from "./PaymentsrecList.vue?vue&type=template&id=4eb4ae96"
import script from "./PaymentsrecList.vue?vue&type=script&lang=js"
export * from "./PaymentsrecList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports